import React, { Component } from "react";
import { connect } from "react-redux";
import LocaleStrings from "../../../../languages/index";

// Import Components
import Loader from "../../../../components/Common/loader";
import CommonHeaderProfileSettings from "../commonheaderprofilesettings";
import ProfileInformationEdit from "./profileinformationedit.js";
// Import Actions
import { fetchUsersDeatils } from "../../actions/index";

class ProfileInformation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      loaderDesc: LocaleStrings.preparing_profile_information,
    };

    // All Binded Functions
  }

  componentDidMount() {
    // Fetch Vendor Details With LoginIdStore

    this.props.fetchUsersDeatils(this.props.session, (callBackResponce) => {
      this.setState({ loading: false });
    });
  }

  render() {
    return (
      <>
        <CommonHeaderProfileSettings
          commonHeaderText={LocaleStrings.profile_settings_list_text1}
        />
        {this.state.loading ? (
          <Loader />
        ) : (
          <>
            <ProfileInformationEdit />
          </>
        )}
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    isLoggedIn: state.isLoggedIn,
    user: state.myProfile,
    session: state.session,
  };
}

export default connect(mapStateToProps, {
  fetchUsersDeatils,
})(ProfileInformation);
